import React from 'react';
import './CardContent.css';

/**
 * CardContent
 * - 아이콘(보라) -> 제목 -> 본문 -> (선택) CTA 버튼
 *
 * props
 * - icon: ReactNode (FontAwesomeIcon 등)
 * - title: string | ReactNode
 * - desc: string | ReactNode
 * - ctaLabel?: string
 * - onCtaClick?: () => void
 * - variant?: 'mv' | 'value' | 'plan' | 'donate'
 */
export default function CardContent({
  icon,
  title,
  desc,
  ctaLabel,
  onCtaClick,
  variant = 'value',
}) {
  return (
    <div className={`card-content card-content--${variant}`}>
      {icon ? <div className="card-content__icon">{icon}</div> : null}

      {title ? <div className="card-content__title">{title}</div> : null}

      {desc ? <div className="card-content__desc">{desc}</div> : null}

      {ctaLabel ? (
        <button type="button" className="card-content__cta" onClick={onCtaClick}>
          {ctaLabel}
        </button>
      ) : null}
    </div>
  );
}
